




import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Skeleton extends Vue {
  @Prop({ type: String, default: '70%' }) width!: string;
  @Prop({ type: String, default: '18px' }) height!: string;
  @Prop({ type: String, default: '0' }) borderRadius!: string;
}
